/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-08-17 15:59:55
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-11-15 17:46:36
 * @FilePath: \sea-page-game\src\config\languages\th-TH.js
 */
module.exports = {
    message: {
        // 首页
        navigator_website: 'เว็บไซต์',
        navigator_collect: 'เก็บสะสม',
        navigator_service: 'GM',
        navigator_teach: 'การสอน',
        navigator_logout: 'ล็อกออก',
        navigator_mobile_logout: 'เบอร์โทร',
        navigator_email_logout: 'อีเมล์',
        navigator_download: 'ดาวน์โหลด',
        // 登录、注册页
        navigator_signIn: 'ลงทะเบียน',
        navigator_lang: 'ล็อกอิน',
        navigator_email: 'อีเมล์',
        input_account: 'ป้อนบัญชี',
        input_mobile: 'ป้อนเบอร์โทร',
        input_password: 'ป้อนรหัสผ่าน',
        input_password_again: 'ป้อนรหัสผ่านอีกครั้ง',
        input_email_address: 'ป้อนที่อยู่อีเมล์',
        input_reset_email: 'ป้อนบัญชีหรืออีเมล์ที่ต้องรีเซ็ตรหัสผ่าน',
        input_reset_password: '，ยืนยันด้วยวิธีต่อไปแล้วตั้งค่ารหัสผ่านใหม่',
        retrieve_password: 'กู้คืนรหัสผ่าน',
        forget_password: 'ลืมรหัสผ่าน',
        next_step: 'ถัดไป',
        bind_email: 'ผูกอีเมล์',
        input_bind_email: 'ป้อนอีเมล์ที่จะผูก',
        bound_email: 'ผูกอีเมล์แล้ว',
        enter_code: 'ป้อนรหัสยืนยัน',
        get_code: 'รับรหัสยืนยัน',
        get_code_seconds: 's',
        security_verification: 'ยืนยันความปลอดภัย',
        inputTheAnswer: 'ป้อนรหัสยืนยันในภาพ',
        noneSelectArea: "เลือกรหัสพื้นที่",
        confirm: 'ยืนยัน',
        bind: 'ผูก',
        agree: 'อ่านและยอมรับ',
        tips_1: 'หลังยืนยันแล้วเบอร์โทรที่ยังไม่ได้ลงทะเบียนจะลงทะเบียนและล็อกอินอัตโนมัติ',
        copy_success: 'ก๊อบปี้สำเร็จ',
        copy_fail: 'ก๊อบปี้แบบแมนนวล',
        incorrect_email: 'ป้อนรูปแบบอีเมล์ที่ถูกต้อง',
        emailTips1: 'รหัสผ่านต้องไม่มีช่องว่างหรืออักษรจีน',
        emailTips2: 'ป้อนรหัสผ่านอย่างน้อย6ตัว',
        emailTips3: 'รหัสผ่านสองครั้งไม่ตรงกัน',
        emailTips4: 'รหัสผ่านผิดพลาด',
        emailTips5: 'ป้อนบัญชีที่รวมด้วยอักษรและตัวเลข4-12ตัว',
        emailTips6: 'กรุณาใส่รหัส 6~20 ตัวอักษรและตัวเลข',
        emailTips7: 'รหัสผ่านสองครั้งไม่ตรงกัน',
        selectAreaCode: 'รหัสพื้นที่',
        urlError: 'ที่อยู่การเข้าถึงปัจจุบันผิดพลาด',
        ThreeTips: 'คำเตือน',
        verifiedTips1:'ต้องการอายุ18ปีขึ้นไปจึงจะเล่นเกมนี้ได้',
        verifiedTips2:'ล็อกอินล้มเหลว คุณต้องยืนยันตัวตนด้วยชื่อจริงก่อนจึงจะสามารถเล่นเกมได้',
        // 底部
        rules_clause: 'ข้อกำหนดการดำเนินงาน',
        privacy_clause: 'นโยบายความเป็นส่วนตัว',
        service_email: 'อีเมล์GM：',
        EmailAddress: 'maplestoryr.th@gmail.com',
        // 教程页
        infoTitle: 'วิธีสอนการเข้าสู่ระบบ PC และการเติมเงิน'
    }
}